<template>
  <div>
    <ejs-dialog
        ref="cartSearchPopupDialog"
        header="카트 검색"
        width="1180"
        height="auto"
        :allowDragging="true"
        :showCloseIcon="true"
        :isModal="true"
        :close="onPopupClose"
    >
      <div class="window">
        <div class="windowContent">
          <div class="content-wrapper">
            <div class="content-lookup">
              <div class="lookup-left">
                <ul class="lookup-condition">
                  <li class="field">
                    <div class="title">카트번호</div>
                    <ul class="content">
                      <li class="item">
                        <input-text ref="cartNo" id="cartNo" v-model="searchFilterOptions.cartNo" @keydown.enter="onClickSearch()"/>
                      </li>
                    </ul>
                  </li>
                  <li class="field">
                    <div class="title">카트종류</div>
                    <ul class="content">
                      <li class="item">
                        <ejs-dropdownlist
                            ref="searchCartKind"
                            v-model="searchFilterOptions.cartKind"
                            :dataSource="commonCodeOptions.cartKind"
                            :allowFiltering="false"
                            :fields="commonCodeOptions.fields"
                            cssClass="lookup-condition-dropdown"
                        >
                        </ejs-dropdownlist>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div class="lookup-lookup">
                  <erp-button button-div="GET" :is-shortcut-button="true" @click.native="onClickSearch()">조회</erp-button>
                </div>
              </div>
            </div>
            <div class="content-body">
              <!-- 활성 : active -->
              <article class="body-article" style="height:500px">
                <section class="article-section section-01">
                  <div class="section-body">
                    <div class="body-grid">
                      <ejs-grid-wrapper
                          ref="grid"
                          v-bind ="initGrid"
                          :isInPopup="true"
                          @onGridDialogDoubleClickedOrEnterKeyed="onConfirmClicked"
                          @actionComplete="gridComplete"
                      />
                    </div>
                  </div>
                </section>
              </article>
            </div>
          </div>
        </div>
        <div class="windowFooter">
          <ul class="button">
            <li class="confirm keyColor">
              <erp-button button-div="SAVE" :is-icon-custom="true" @click.native="onConfirmClicked">확인</erp-button>
            </li>
            <li class="close">
              <erp-button button-div="CLOSE" @click.native="onPopupClose">닫기</erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
  </div>
</template>

<style scoped>
</style>

<script>
import ejsGridWrapper from "@/components/common/EjsGridWrapper.vue";
import {ExcelExport, Filter, ForeignKey, Page, Resize, Edit} from "@syncfusion/ej2-vue-grids";
import InputText from "@/components/common/text/InputText";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import ErpButton from "@/components/button/ErpButton.vue";
import {getFormattedDate} from "@/utils/date";
import StockCommon from "@/api/v2/StockManage/StockCommon";
import {commonCodesGetCommonCode} from "@/utils/commonCodes";

export default {
  name: "cartSearchPopup",
  mixins: [confirmDialogMixin],
  components: {
    InputText,
    ejsGridWrapper,
    ErpButton,
  },
  /**
   * ##################################### 화면 시작시 DATA API ########################################
   */
  created() {
  },
  /**
   * ##################################### 데이터 필드 정의 ########################################
   */
  data() {
    return {
      gridField: {
        title: "카트목록",
        count : 0,
        dataSource: [],
      },
      searchFilterOptions: {
        cartNo: "",
        cartKind:""
      },
      commonCodeOptions: {
        cartKind: commonCodesGetCommonCode("CART_KIND",false,true,"",""),
        cartStatus: commonCodesGetCommonCode("CART_STATUS",false,true,"",""),
        fields: { text: "comName", value: "comCode" },
      },
    };
  },

  async mounted() {
    // 기본 포커싱
    this.$refs["cartName"].focus();
  },

  /**
   * ##################################### 그리드 정의 ########################################
   */
  computed: {
    initGrid() {
      return {
        columns: [
          { field: "cartId",       textAlign: 'center',  allowEditing: false, width: 70,   visible: true,  type: "string",  headerText: "카트코드", isPrimaryKey: true, },
          { field: "cartKind",     textAlign: 'center',  allowEditing: false, width: 80,   visible: true,  type: "string",  headerText: "카트종류", isCommonCodeField: true, dataSource: this.commonCodeOptions.cartKind},
          { field: "cartNo",       textAlign: 'center',  allowEditing: false, width: 70,   visible: true,  type: "string",  headerText: "카트번호", },
          { field: "cartName",     textAlign: 'left',    allowEditing: false, width: 150,  visible: true,  type: "string",  headerText: "카트명", },
          { field: "cartStatus",   textAlign: 'center',  allowEditing: false, width: 60,   visible: true,  type: "string",  headerText: "상태",    isCommonCodeField: true, dataSource: this.commonCodeOptions.cartStatus},
          {field: "purchsDate",    textAlign: 'center',  allowEditing: false, width: 80,   visible: true,  type: "string",  headerText: "구입일자",
            valueAccessor: (field,data) => getFormattedDate(data[field]) },
          {field: "dsuseDate",     textAlign: 'center',  allowEditing: false, width: 80,   visible: false, type: "string",  headerText: "폐기일자",
            valueAccessor: (field,data) => getFormattedDate(data[field]) },
          { field: "mnfctCompany", textAlign: 'left',    allowEditing: false, width: 100,  visible: true,  type: "string",  headerText: "제조사", },
          { field: "cartUseFuel",  textAlign: 'center',  allowEditing: false, width: 60,   visible: true,  type: "string",  headerText: "사용유류", },
          { field: "remarks_1",    textAlign: 'left',    allowEditing: false, width: 180,  visible: true,  type: "string",  headerText: "비고1", },
          { field: "remarks_2",    textAlign: 'left',    allowEditing: false, width: 180,  visible: true,  type: "string",  headerText: "비고2", },
          { field: "dsuseFlag",    textAlign: 'center',  allowEditing: false, width: 60,   visible: false, type: "boolean", headerText: "사용여부", displayAsCheckBox: true, editType: "booleanedit", },
        ],
        provides: [ExcelExport, Filter, ForeignKey, Page, Resize, Edit],
        dataSource: this.gridField.dataSource,

        allowResizing: true,
        allowSorting: true,
        allowFiltering: true,
        allowExcelExport: true,
        isShowProgress: true,
        isNOColumnDisplay:true,
        noColumnWidth: 35,
        isSelectedRowRetain: true,
        selectionSettings: {type: "Single", mode: "Row", enableToggle: false, persistSelection: false,},
        allowPaging: true,
        pageSettings: { pageSize: 50 },
        resizeSettings: {mode:"Normal"},
      };
    },
  },

  /** ##################################### 화면 이벤트 ######################################## */
  methods: {
    //region******************************* 버튼 이벤트 *******************************
    //조회
    async onClickSearch() {
      this.gridField.dataSource = await StockCommon.getCartCodeListPop(this.searchFilterOptions);
    },
    //확인및 더블클릭
    onConfirmClicked() {
      const selData = this.$refs.grid.getSelectedRecords();
      if(selData?.length == 0){
        this.errorToast("카트를 선택해 주십시오");
      }else{
        this.$emit("popupConfirmed", selData[0]);
      }
    },
    //팝업 닫기
    onPopupClose(){
      this.$emit('popupConfirmed', null);
    },
    //endregion
    //region******************************* 그리드 이벤트 *******************************
    //그리드 헤더 이미지적용
    onHeaderCellInfo(args){
      const {cell: {column:{field}}, node} = args;
      if(this.$refs.grid.validationRules[field]?.required){
        node.classList.add(this.$t("className.grid.requiredInputHeader"));
      }
      if (['cartName'].includes(field)) {
        node.classList.add(this.$t('className.grid.clickArea'));
      }
    },
    //그리드 셀 이미지 적용
    onQueryCellInfo(args){
      const {column:{field,allowEditing}, cell} = args;
      if(allowEditing && field){
        cell.classList.add(this.$t('className.grid.modifyArea'));
      }
      if (['cartName'].includes(field)) {
        cell.classList.add(this.$t('className.grid.clickArea'));
      }
    },
    //그리드 조회 완료시(카운트)
    gridComplete(){
      this.gridField.count = this.$refs.grid.getGridBatchCount();
    },
    //endregion
  },
};
</script>
